import { generateApiPath } from "@routes/generatePath.ts";
import type { IExtractApiParams } from "@routes/types.ts";

const pathBase = `/infinite/`;
const hfPath = `${pathBase}hf/`;
const patientsPath = `${pathBase}patients/`;
const doctorPath = `${pathBase}doctors/`;
const staffPath = `${pathBase}staffs/`;
const assignableDoctorsToStaffPath = `${pathBase}doctor-names/:staffId/`;
const assignableDoctorsToMspPath = `/infinite/msp-doctor-names/:mspId`;
const patternsPath = `${pathBase}patterns/:pattern_type/`;
const suggestedPatternsPath = `${pathBase}suggested-patterns/:pattern_type/`;
const terminologiesPath = `${pathBase}terminologies/:terminology_id`;
const visitHistoriesPath = `dropdown/prescription-histories/:id/:type`;
const diseasesPath = `${pathBase}icd-terminologies`;
const mspPath = `/medical-service-provider/dropdown/msp-names`;

export type IAssignableDoctorsToStaffParams = IExtractApiParams<
  typeof assignableDoctorsToStaffPath
>;

export type IAssignableDoctorsToMspParams = IExtractApiParams<
  typeof assignableDoctorsToMspPath
>;

export type IPatternsParams = IExtractApiParams<typeof patternsPath>;

export type ISuggestedPatternsParams = IExtractApiParams<
  typeof suggestedPatternsPath
>;

export type ITerminologiesParams = IExtractApiParams<typeof terminologiesPath>;
export type IVisitHistoriesParams = IExtractApiParams<
  typeof visitHistoriesPath
>;

export const infinite = {
  getAllHFs: () => generateApiPath(hfPath),
  getAllPatients: () => generateApiPath(patientsPath),
  getAllDoctors: () => generateApiPath(doctorPath),
  getAllStaffs: () => generateApiPath(staffPath),
  getAllAssignableDoctorsToStaff: (params: IAssignableDoctorsToStaffParams) =>
    generateApiPath(assignableDoctorsToStaffPath, params),
  getAllAssignableDoctorsToMsp: (params: IAssignableDoctorsToMspParams) =>
    generateApiPath(assignableDoctorsToMspPath, params),
  getAllPatterns: (params: IPatternsParams) =>
    generateApiPath(patternsPath, params),
  getAllSuggestedPatterns: (params: ISuggestedPatternsParams) =>
    generateApiPath(suggestedPatternsPath, params),
  getAllTerminologies: (params: ITerminologiesParams) =>
    generateApiPath(terminologiesPath, params),
  getAllVisitHistories: (params: IVisitHistoriesParams) =>
    generateApiPath(visitHistoriesPath, params),
  getAllDiseases: () => generateApiPath(diseasesPath),
  getAllMsp: () => generateApiPath(mspPath),
};
